import request from '../../../core/wrappers/axios-wrapper';
import { AutoReturnAndResendUrls } from '../../../types/constants/apiUrls/autoReturnAndResend/autoReturnAndResendUrls';
import { RequestType } from '../../../types/enums/request-enums';
import type {
    CheckAutoReturnAndResendStatusRequest,
    CheckAutoReturnAndResendStatusResponse,
    ProcessAutoReturnBulkRequest,
    ProcessAutoReturnBulkResponse,
} from '../../../pages/AutoReturnAndResend/autoReturnAndResend.types';

export const CheckAutoReturnAndResendStatus = (
    shippingListNumbers: CheckAutoReturnAndResendStatusRequest['shippingListNumbers']
): Promise<CheckAutoReturnAndResendStatusResponse> =>
    request({
        url: AutoReturnAndResendUrls.checkStatus,
        method: RequestType.POST,
        data: { shippingListNumbers },
    });

export const ProcessAutoReturnBulk = (
    shippingListNumbers: ProcessAutoReturnBulkRequest['shippingListNumbers']
): Promise<ProcessAutoReturnBulkResponse> =>
    request({
        url: AutoReturnAndResendUrls.processBulk,
        method: RequestType.POST,
        data: { shippingListNumbers },
    });

const AutoReturnAndResendCommand = {
    CheckAutoReturnAndResendStatus,
    ProcessAutoReturnBulk,
};

export default AutoReturnAndResendCommand;
